module.exports = __webpack_public_path__ + "img/gh-31501____-48.prt.f573e017.jpg";